/**
 * Make sure this file appears at the top.
 */
$(document).ready(function () {
    /**
     * MSIE is used for IE 10 and under, Trident for IE 11
     */
    function isIE() {
        const ua = navigator.userAgent;
        return ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1;
    }

    function checkDonorUserAgent() {
        if (document.getElementById('ie_header_error_holder') && isIE()) {
            $('#ie_header_error_holder .js-upgrade-browser-link').on('click', function () {
                const show = $('#other-browsers').css('display') === 'none';
                if (show) {
                    $('#other-browsers').show();
                } else {
                    $('#other-browsers').hide();
                }
                return false;
            });
            document.getElementById('ie_header_error_holder').style.display = 'block';
        }
    }

    checkDonorUserAgent();
});
